'use client'

import type { CSSProperties, ElementType, ReactNode } from 'react'
import { createElement } from 'react'
import { useAccent, type AccentVar } from './AccentContext'

interface TitleProps {
  text?: ReactNode
  mark?: ReactNode
  accent?: AccentVar
  as?: ElementType
  children?: ReactNode
  style?: CSSProperties
}

export function Title({ text, mark, accent, as = 'h1', children, style }: TitleProps) {
  const { v } = useAccent()
  const a = accent || v
  return createElement(
    as,
    { className: 'st-title', style },
    <>
      {text ?? children}
      {mark ? (
        <>
          {' '}
          <em style={{ background: `var(${a})` }}>{mark}</em>
        </>
      ) : null}
    </>
  )
}
